(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  function initWpcProductsMenu(root = document) {
    root.querySelectorAll('.wpc-products-toggle').forEach(button => {
      if (button.dataset.menuReady) return;
      const item = button.closest('.header__nav-item');
      const dropdown = document.getElementById(button.getAttribute('aria-controls'));
      const nav = button.closest('nav');
      const header = button.closest('.header');
      if (!item || !dropdown || !nav) return;
      button.dataset.menuReady = 'true';
      const syncState = () => {
        button.setAttribute('aria-expanded', String(dropdown.classList.contains('is-visible')));
        header?.classList.toggle('is-megamenu-open', Boolean(nav.querySelector('.js-dropdown.is-visible')));
      };
      const close = () => {
        dropdown.classList.remove('is-visible');
        syncState();
      };
      button.addEventListener('click', () => {
        nav.querySelectorAll('.js-dropdown.is-visible').forEach(menu => {
          if (menu !== dropdown) menu.classList.remove('is-visible');
        });
        dropdown.classList.add('is-visible');
        syncState();
      });
      item.addEventListener('keydown', event => {
        if (event.key !== 'Escape') return;
        event.preventDefault();
        close();
        button.focus();
      });
      item.addEventListener('focusout', event => {
        if (!item.contains(event.relatedTarget)) close();
      });
      document.addEventListener('pointerdown', event => {
        if (!item.contains(event.target)) close();
      });
      new MutationObserver(syncState).observe(dropdown, { attributes: true, attributeFilter: ['class'] });
      syncState();
    });
  }
  initWpcProductsMenu();
  document.addEventListener('shopify:section:load', event => initWpcProductsMenu(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter-popup"]) return;
  try {
    
  if (!customElements.get('newsletter-popup')) {
    class WpcNewsletterPopup extends ModalDialog {
      constructor() {
        super();
        this.delay = Number(this.dataset.delay || 45) * 1000;
        this.dismissDays = Number(this.dataset.dismissDays || 7);
        this.form = this.querySelector('.js-form');
        this.closeButtons = this.querySelectorAll('.js-button-close');
        this.destinationLinks = this.querySelectorAll('[data-popup-destination]');
        this.testMode = new URLSearchParams(window.location.search).get('newsletter_popup_test') === '1';
        this.timer = null;

        this.closeButtons.forEach(button => {
          button.addEventListener('click', this.closeNewsletter.bind(this));
        });

        this.addEventListener('click', event => {
          if (event.target === this) this.closeNewsletter();
        });

        if (this.form) this.form.addEventListener('submit', this.onSubscribe.bind(this));
        this.destinationLinks.forEach(link => link.addEventListener('click', this.onDestinationClick.bind(this)));
      }

      connectedCallback() {
        if (this.wpcConnected) return;
        this.wpcConnected = true;
        super.connectedCallback();

        if (Shopify.designMode) {
          if (this.dataset.openInDesignMode === 'true') this.show();
          return;
        }

        if (this.testMode) {
          this.timer = window.setTimeout(() => this.show(), 250);
          return;
        }

        if (getCookie('newsletter-closed') === 'true') return;
        if (getCookie('newsletter-subscribed') === 'true') return;

        this.timer = window.setTimeout(() => this.show(), this.delay);
      }

      disconnectedCallback() {
        if (this.timer) window.clearTimeout(this.timer);
      }

      hide() {
        setCookie('newsletter-closed', 'true', this.dismissDays);
        super.hide();
      }

      closeNewsletter() {
        this.hide();
      }

      onSubscribe() {
        setCookie('newsletter-subscribed', 'true', 365);
        super.hide();
      }

      onDestinationClick(event) {
        this.hide();
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        const destination = new URL(event.currentTarget.href, window.location.href);
        if (destination.origin === window.location.origin && destination.pathname === window.location.pathname && destination.hash) {
          const target = document.getElementById(decodeURIComponent(destination.hash.slice(1)));
          if (target) {
            event.preventDefault();
            history.pushState(null, '', destination.href);
            requestAnimationFrame(() => target.scrollIntoView({ block: 'start', behavior: 'auto' }));
          }
        }
      }
    }

    customElements.define('newsletter-popup', WpcNewsletterPopup);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wpc-archive-sale"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('wpc-archive-sale')) {
  customElements.define('wpc-archive-sale', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const toolbar = this.querySelector('.wpc-as-tools');
      if (toolbar) toolbar.hidden = false;
      const buttons = [...this.querySelectorAll('[data-as-filter]')];
      const cards = [...this.querySelectorAll('[data-as-grid] .wpc-as-card')];
      const count = this.querySelector('[data-as-count]');
      buttons.forEach(button => button.addEventListener('click', () => {
        const kind = button.dataset.asFilter;
        let visible = 0;
        cards.forEach(card => { card.hidden = kind !== 'all' && card.dataset.asKind !== kind; if (!card.hidden) visible++; });
        buttons.forEach(item => item.setAttribute('aria-pressed', String(item === button)));
        if (count) count.textContent = String(visible);
      }));
      this.addEventListener('shopify:block:select', () => buttons[0]?.click());
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wpc-consultation-booking"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('wpc-consultation')) return;
  function prepareCal() {
    if (window.Cal) return;
    (function (C, A, L) {
      let p = function (a, ar) { a.q.push(ar); };
      let d = C.document;
      C.Cal = C.Cal || function () {
        let cal = C.Cal;
        let ar = arguments;
        if (!cal.loaded) {
          cal.ns = {};
          cal.q = cal.q || [];
          const script = d.createElement('script');
          script.src = A;
          script.async = true;
          d.head.appendChild(script);
          cal.loaded = true;
        }
        if (ar[0] === L) {
          const api = function () { p(api, arguments); };
          const namespace = ar[1];
          api.q = api.q || [];
          if (typeof namespace === 'string') {
            cal.ns[namespace] = cal.ns[namespace] || api;
            p(cal.ns[namespace], ar);
            p(cal, ['initNamespace', namespace]);
          } else p(cal, ar);
          return;
        }
        p(cal, ar);
      };
    })(window, 'https://app.cal.com/embed/embed.js', 'init');
  }

  class WpcConsultation extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      this.buttons = [...this.querySelectorAll('[data-location]')];
      this.panel = this.querySelector('[data-calendar-panel]');
      this.embed = this.querySelector('[data-embed]');
      this.active = this.querySelector('[data-active]');
      this.empty = this.querySelector('[data-empty]');
      this.status = this.querySelector('[data-status]');
      this.error = this.querySelector('[data-error]');
      this.messages = JSON.parse(this.querySelector('[data-consult-messages]').textContent);
      this.buttons.forEach(button => button.addEventListener('click', () => this.choose(button)));
      this.querySelector('[data-change]').addEventListener('click', () => this.reset());
      this.querySelector('[data-retry]').addEventListener('click', () => window.location.reload());
      this.observer = new IntersectionObserver(() => this.updateChat(), {threshold:0});
      this.observer.observe(this.panel);
      this.frameObserver = new MutationObserver(() => {
        const frame = this.embed.querySelector('iframe');
        if (frame && this.current) frame.title = this.messages.frame_title.replace('[Standort]',this.current.dataset.city);
      });
      this.frameObserver.observe(this.embed,{childList:true,subtree:true});
    }
    updateChat() {
      document.body.toggleAttribute('data-wpc-consultation-open',!!document.querySelector('wpc-consultation[data-selected]'));
      const box = this.panel.getBoundingClientRect();
      this.toggleAttribute('data-in-view',!!this.current && box.bottom > 0 && box.top < innerHeight);
      document.body.toggleAttribute('data-wpc-consultation-in-view',!!document.querySelector('wpc-consultation[data-in-view]'));
    }
    choose(button) {
      if (button === this.current) return;
      clearTimeout(this.timer);
      this.current = button;
      const token = Symbol();
      this.requestToken = token;
      this.buttons.forEach(item => item.setAttribute('aria-pressed',String(item === button)));
      this.setAttribute('data-selected','');
      this.empty.hidden = true;
      this.active.hidden = false;
      this.status.hidden = false;
      this.error.hidden = true;
      this.querySelector('[data-success]').hidden = true;
      this.embed.replaceChildren();
      this.embed.setAttribute('aria-busy','true');
      let heading = this.querySelector('[data-calendar-heading]');
      if (!heading) {
        heading = document.createElement('h3');
        heading.tabIndex = -1;
        heading.setAttribute('data-calendar-heading','');
        this.querySelector('[data-calendar-heading-slot]').appendChild(heading);
      }
      heading.textContent = this.messages.selected_heading.replace('[Standort]',button.dataset.city);
      const details = [...this.querySelectorAll('[data-details-for]')].find(item => item.dataset.detailsFor === button.dataset.location);
      this.querySelector('[data-selected-details]').replaceChildren(details.content.cloneNode(true));
      heading.focus({preventScroll:true});
      this.panel.scrollIntoView({behavior:'instant',block:'start'});
      this.updateChat();
      try {
        if (!/^team\/whirlpool-center\/[a-z0-9-]+$/.test(button.dataset.bookingPath)) throw new Error('Invalid booking path');
        prepareCal();
        const namespace = this.dataset.namespace + '-' + Date.now().toString(36);
        window.Cal('init',namespace,{origin:'https://cal.com'});
        const api = window.Cal.ns[namespace];
        const ready = () => {
          if (!this.isConnected || this.requestToken !== token) return;
          clearTimeout(this.timer);
          this.status.hidden = true;
          this.error.hidden = true;
          this.embed.removeAttribute('aria-busy');
          this.updateChat();
        };
        api('on',{action:'linkReady',callback:ready});
        api('on',{action:'linkFailed',callback:() => this.fail(token)});
        api('on',{action:'bookingSuccessfulV2',callback:() => {
          if (this.requestToken !== token) return;
          ready();this.querySelector('[data-success]').hidden = false;
        }});
        api('inline',{elementOrSelector:this.embed,calLink:button.dataset.bookingPath,config:{layout:'month_view',theme:'light',locale:'de'}});
        const accent = getComputedStyle(this).getPropertyValue('--consult-accent').trim() || '#034040';
        api('ui',{theme:'light',hideEventTypeDetails:true,showTimezoneWhenEventDetailsHidden:true,layout:'month_view',cssVarsPerTheme:{light:{'cal-brand':accent,'cal-brand-emphasis':'#0b5553','cal-brand-text':'#ffffff','cal-text':'#486160','cal-text-emphasis':'#173d3c','cal-text-subtle':'#627674','cal-bg':'#ffffff','cal-bg-emphasis':'#e9f0ec','cal-bg-subtle':'#f3f5f3','cal-border':'#d4dfda','cal-border-booker':'transparent','cal-border-booker-width':'0px','radius':'2px'}}});
        this.timer = setTimeout(() => this.fail(token),30000);
      } catch (error) { this.fail(token); }
    }
    fail(token) {
      if (this.requestToken !== token || !this.current) return;
      clearTimeout(this.timer);this.status.hidden=true;this.error.hidden=false;this.embed.removeAttribute('aria-busy');
    }
    reset() {
      const previous = this.current;
      this.current=null;this.requestToken=null;clearTimeout(this.timer);
      this.removeAttribute('data-selected');this.active.hidden=true;this.empty.hidden=false;
      this.querySelector('[data-calendar-heading-slot]').replaceChildren();
      this.embed.replaceChildren();this.buttons.forEach(button => button.setAttribute('aria-pressed','false'));
      this.updateChat();
      (previous || this.querySelector('[data-selection-heading]')).focus({preventScroll:true});
      this.querySelector('[data-selection]').scrollIntoView({behavior:'instant',block:'start'});
    }
    disconnectedCallback() {
      clearTimeout(this.timer);this.observer?.disconnect();this.frameObserver?.disconnect();
      this.requestToken=null;this.current=null;this.removeAttribute('data-selected');this.removeAttribute('data-in-view');
      document.body.toggleAttribute('data-wpc-consultation-open',!!document.querySelector('wpc-consultation[data-selected]'));
      document.body.toggleAttribute('data-wpc-consultation-in-view',!!document.querySelector('wpc-consultation[data-in-view]'));
    }
  }
  customElements.define('wpc-consultation',WpcConsultation);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wpc-danke-erfolgreich"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('wpc-thanks-section')) {
  customElements.define('wpc-thanks-section', class extends HTMLElement {
    connectedCallback() {
      this.previousCompact = undefined;
      this.onBlockSelect = event => {
        const details = event.target.closest('details');
        if (details && this.contains(details)) details.open = true;
      };
      this.addEventListener('shopify:block:select', this.onBlockSelect);
      queueMicrotask(() => {
        if (!this.isConnected) return;
        this.nextSteps = this.querySelector('.wpc-next');
        if (!this.nextSteps || this.dataset.collapseMobile !== 'true' || !('ResizeObserver' in window)) return;
        this.observer = new ResizeObserver(entries => {
          const compact = entries[0].contentRect.width <= 620;
          if (compact !== this.previousCompact) {
            this.nextSteps.open = !compact;
            this.previousCompact = compact;
          }
        });
        this.observer.observe(this);
      });
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.removeEventListener('shopify:block:select', this.onBlockSelect);
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wpc-jubilee-popup"]) return;
  try {
    
  if (!customElements.get('newsletter-popup')) {
    class WpcNewsletterPopup extends ModalDialog {
      constructor() {
        super();
        this.delay = Number(this.dataset.delay || 45) * 1000;
        this.dismissDays = Number(this.dataset.dismissDays || 7);
        this.form = this.querySelector('.js-form');
        this.closeButtons = this.querySelectorAll('.js-button-close');
        this.destinationLinks = this.querySelectorAll('[data-popup-destination]');
        this.testMode = new URLSearchParams(window.location.search).get('newsletter_popup_test') === '1';
        this.timer = null;

        this.closeButtons.forEach(button => {
          button.addEventListener('click', this.closeNewsletter.bind(this));
        });

        this.addEventListener('click', event => {
          if (event.target === this) this.closeNewsletter();
        });

        if (this.form) this.form.addEventListener('submit', this.onSubscribe.bind(this));
        this.destinationLinks.forEach(link => link.addEventListener('click', this.onDestinationClick.bind(this)));
      }

      connectedCallback() {
        if (this.wpcConnected) return;
        this.wpcConnected = true;
        super.connectedCallback();

        if (Shopify.designMode) {
          if (this.dataset.openInDesignMode === 'true') this.show();
          return;
        }

        if (this.testMode) {
          this.timer = window.setTimeout(() => this.show(), 250);
          return;
        }

        if (getCookie('newsletter-closed') === 'true') return;
        if (getCookie('newsletter-subscribed') === 'true') return;

        this.timer = window.setTimeout(() => this.show(), this.delay);
      }

      disconnectedCallback() {
        if (this.timer) window.clearTimeout(this.timer);
      }

      hide() {
        setCookie('newsletter-closed', 'true', this.dismissDays);
        super.hide();
      }

      closeNewsletter() {
        this.hide();
      }

      onSubscribe() {
        setCookie('newsletter-subscribed', 'true', 365);
        super.hide();
      }

      onDestinationClick(event) {
        this.hide();
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        const destination = new URL(event.currentTarget.href, window.location.href);
        if (destination.origin === window.location.origin && destination.pathname === window.location.pathname && destination.hash) {
          const target = document.getElementById(decodeURIComponent(destination.hash.slice(1)));
          if (target) {
            event.preventDefault();
            history.pushState(null, '', destination.href);
            requestAnimationFrame(() => target.scrollIntoView({ block: 'start', behavior: 'auto' }));
          }
        }
      }
    }

    customElements.define('newsletter-popup', WpcNewsletterPopup);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wpc-outdoor-zigzag"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('wpc-zigzag-video')) {
    customElements.define('wpc-zigzag-video', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready) return;
        const video = this.querySelector('video');
        const play = this.querySelector('button');
        if (!video || !play) return;
        this.dataset.ready = 'true';
        video.controls = false;
        video.tabIndex = 0;
        const start = (manual = false) => {
          if (manual) {
            this.dataset.interacted = 'true';
            video.controls = true;
            video.focus();
          }
          if (!video.paused) return;
          const attempt = video.play();
          if (attempt) attempt.catch(() => {
            delete this.dataset.started;
            video.controls = this.dataset.interacted === 'true';
          });
        };
        play.addEventListener('click', () => {
          this.observer?.disconnect();
          start(true);
        });
        video.addEventListener('play', () => { this.dataset.started = 'true'; });
        if (this.dataset.autoplay === 'true' && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          video.muted = true;
          video.defaultMuted = true;
          video.playsInline = true;
          if ('IntersectionObserver' in window) {
            this.observer = new IntersectionObserver(entries => {
              if (entries.some(entry => entry.isIntersecting)) {
                this.observer.disconnect();
                if (video.paused) start();
              }
            }, { threshold: 0.15 });
            this.observer.observe(this);
          } else {
            start();
          }
        }
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        this.querySelector('video')?.pause();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wpc-showroom-booking"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('wpc-showroom-booking')) return;
  function prepareCal() {
    if (window.Cal) return;
    (function (C, A, L) {
      let p = function (a, ar) { a.q.push(ar); };
      let d = C.document;
      C.Cal = C.Cal || function () {
        let cal = C.Cal;
        let ar = arguments;
        if (!cal.loaded) {
          cal.ns = {};
          cal.q = cal.q || [];
          const script = d.createElement('script');
          script.src = A;
          script.async = true;
          d.head.appendChild(script);
          cal.loaded = true;
        }
        if (ar[0] === L) {
          const api = function () { p(api, arguments); };
          const namespace = ar[1];
          api.q = api.q || [];
          if (typeof namespace === 'string') {
            cal.ns[namespace] = cal.ns[namespace] || api;
            p(cal.ns[namespace], ar);
            p(cal, ['initNamespace', namespace]);
          } else p(cal, ar);
          return;
        }
        p(cal, ar);
      };
    })(window, 'https://app.cal.com/embed/embed.js', 'init');
  }
  class WpcShowroomBooking extends HTMLElement {
    connectedCallback() {
      if (this.bound) {
        this.observer?.observe(this.panel);
        this.frameObserver?.observe(this.embed, { childList: true, subtree: true });
        return;
      }
      this.bound = true;
      this.opened = false;
      this.initialized = false;
      this.ready = false;
      this.welcome = this.querySelector('[data-welcome]');
      this.panel = this.querySelector('[data-calendar-panel]');
      this.embed = this.querySelector('[data-embed]');
      this.toolbar = this.querySelector('[data-toolbar]');
      this.status = this.querySelector('[data-status]');
      this.error = this.querySelector('[data-error]');
      this.openButton = this.querySelector('[data-open]');
      this.messages = JSON.parse(this.querySelector('[data-messages]').textContent);
      this.openButton.addEventListener('click', () => this.open());
      this.querySelector('[data-close]').addEventListener('click', () => this.close());
      this.querySelector('[data-retry]').addEventListener('click', () => window.location.reload());
      this.observer = new IntersectionObserver(entries => {
        this.inView = entries[0].isIntersecting;
        this.updateChat();
      }, { threshold: 0 });
      this.observer.observe(this.panel);
      this.frameObserver = new MutationObserver(() => {
        const frame = this.embed.querySelector('iframe');
        if (frame && frame.title !== this.messages.frame_title) frame.title = this.messages.frame_title;
      });
      this.frameObserver.observe(this.embed, { childList: true, subtree: true });
    }
    updateChat() {
      this.toggleAttribute('data-booking-open', this.opened);
      document.body.toggleAttribute('data-wpc-booking-open', !!document.querySelector('wpc-showroom-booking[data-booking-open]'));
      const bounds = this.panel.getBoundingClientRect();
      if (this.opened && bounds.bottom > 0 && bounds.top < window.innerHeight) this.setAttribute('data-in-view', '');
      else this.removeAttribute('data-in-view');
      document.body.toggleAttribute('data-wpc-booking-in-view', !!document.querySelector('wpc-showroom-booking[data-in-view]'));
    }
    open() {
      this.opened = true;
      this.welcome.hidden = true;
      this.toolbar.hidden = false;
      this.embed.hidden = false;
      this.openButton.setAttribute('aria-expanded', 'true');
      this.querySelector('[data-calendar-heading]').focus({ preventScroll: true });
      this.panel.scrollIntoView({ behavior: 'instant', block: 'start' });
      this.updateChat();
      if (this.initialized) return;
      this.initialized = true;
      this.status.hidden = false;
      this.status.textContent = this.messages.loading;
      this.embed.setAttribute('aria-busy', 'true');
      try {
        if (!/^team\/whirlpool-center\/[a-z0-9-]+$/.test(this.dataset.bookingPath)) throw new Error('Invalid booking path');
        prepareCal();
        const namespace = this.dataset.namespace + '-' + Date.now().toString(36);
        window.Cal('init', namespace, { origin: 'https://cal.com' });
        const api = window.Cal.ns[namespace];
        const ready = () => {
          if (!this.isConnected) return;
          this.ready = true;
          clearTimeout(this.timer);
          this.status.hidden = true;
          this.error.hidden = true;
          this.embed.removeAttribute('aria-busy');
          this.updateChat();
        };
        api('on', { action: 'linkReady', callback: ready });
        api('on', { action: 'linkFailed', callback: () => this.fail() });
        api('on', { action: 'bookingSuccessfulV2', callback: () => {
          ready();
          this.querySelector('[data-success]').hidden = false;
        }});
        api('inline', {
          elementOrSelector: this.embed,
          calLink: this.dataset.bookingPath,
          config: { layout: 'month_view', theme: 'light', locale: document.documentElement.lang.startsWith('de') ? 'de' : 'en' }
        });
        const accent = getComputedStyle(this).getPropertyValue('--wpc-booking-accent').trim() || '#034040';
        api('ui', {
          theme: 'light',
          hideEventTypeDetails: true,
          showTimezoneWhenEventDetailsHidden: true,
          layout: 'month_view',
          cssVarsPerTheme: { light: { 'cal-brand': accent, 'cal-brand-emphasis': '#0b5553', 'cal-brand-text': '#ffffff', 'cal-text': '#486160', 'cal-text-emphasis': '#173d3c', 'cal-text-subtle': '#627674', 'cal-bg': '#ffffff', 'cal-bg-emphasis': '#e9f0ec', 'cal-bg-subtle': '#f3f5f3', 'cal-border': '#d4dfda', 'cal-border-booker': 'transparent', 'cal-border-booker-width': '0px', 'radius': '2px' } }
        });
        this.timer = setTimeout(() => { if (!this.ready) this.fail(); }, 30000);
      } catch (error) { this.fail(); }
    }
    fail() {
      clearTimeout(this.timer);
      this.status.hidden = true;
      this.error.hidden = false;
      this.embed.removeAttribute('aria-busy');
    }
    close() {
      this.opened = false;
      this.welcome.hidden = false;
      this.toolbar.hidden = true;
      this.embed.hidden = true;
      this.status.hidden = true;
      this.error.hidden = true;
      this.querySelector('[data-success]').hidden = true;
      this.openButton.setAttribute('aria-expanded', 'false');
      this.updateChat();
      this.openButton.focus({ preventScroll: true });
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      this.observer?.disconnect();
      this.frameObserver?.disconnect();
      this.removeAttribute('data-in-view');
      this.removeAttribute('data-booking-open');
      document.body.toggleAttribute('data-wpc-booking-open', !!document.querySelector('wpc-showroom-booking[data-booking-open]'));
      document.body.toggleAttribute('data-wpc-booking-in-view', !!document.querySelector('wpc-showroom-booking[data-in-view]'));
    }
  }
  customElements.define('wpc-showroom-booking', WpcShowroomBooking);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wpc-standorte"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('wpc-location-directory')) {
  customElements.define('wpc-location-directory', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options={signal:this.controller.signal};
      this.region='all';
      this.version=0;
      this.search=this.querySelector('[data-search]');
      this.cards=Array.from(this.querySelectorAll('[data-location]'));
      this.grid=this.querySelector('[data-locations]');
      this.status=this.querySelector('[data-search-status]');
      if(!this.search||!this.status)return;
      this.querySelectorAll('[data-controls]').forEach(el=>{el.hidden=false;});
      this.search.addEventListener('input',()=>{
        this.region='all';
        this.version++;
        clearTimeout(this.timer);
        this.timer=setTimeout(()=>this.filter(),250);
      },options);
      this.querySelector('[data-search-form]').addEventListener('submit',event=>{event.preventDefault();clearTimeout(this.timer);this.filter();},options);
      this.querySelector('[data-clear]').addEventListener('click',()=>{this.reset();this.search.focus();},options);
      this.querySelectorAll('[data-region]').forEach(button=>button.addEventListener('click',()=>{this.search.value='';this.region=button.dataset.region;this.filter();},options));
      this.querySelector('[data-reset]').addEventListener('click',()=>{this.reset();this.search.focus();},options);
      this.addEventListener('shopify:block:select',event=>{
        const card=event.target.closest('[data-location]');
        if(card){this.reset();card.scrollIntoView({block:'center',behavior:'auto'});}
        const details=event.target.closest('details');
        if(details)details.open=true;
      },options);
      this.filter();
    }
    disconnectedCallback(){this.controller?.abort();this.controller=null;this.version++;clearTimeout(this.timer);}
    normalize(value){return String(value||'').toLocaleLowerCase('de').replaceAll('ä','ae').replaceAll('ö','oe').replaceAll('ü','ue').replaceAll('ß','ss').replace(/\s+/g,' ').trim();}
    reset(){clearTimeout(this.timer);this.region='all';this.search.value='';this.filter();}
    distance(a,b){const r=Math.PI/180,dLat=(b[0]-a[0])*r,dLon=(b[1]-a[1])*r;const h=Math.sin(dLat/2)**2+Math.cos(a[0]*r)*Math.cos(b[0]*r)*Math.sin(dLon/2)**2;return 6371*2*Math.atan2(Math.sqrt(h),Math.sqrt(Math.max(0,1-h)));}
    centre(rows){return [rows.reduce((s,r)=>s+r[2],0)/rows.length,rows.reduce((s,r)=>s+r[3],0)/rows.length];}
    async loadPlaces(){
      if(this.places)return this.places;
      if(!this.loading)this.loading=(async()=>{
        const response=await fetch(this.dataset.postcodesUrl,{credentials:'omit',signal:AbortSignal.timeout(8000)});
        if(!response.ok)throw new Error('Postcode data unavailable');
        const data=await response.json();
        if(!Array.isArray(data.places)||!data.places.length)throw new Error('Invalid postcode data');
        this.places=data.places.filter(r=>/^\d{5}$/.test(r[0])&&typeof r[1]==='string'&&Number.isFinite(r[2])&&Number.isFinite(r[3]));
        return this.places;
      })().finally(()=>{this.loading=null;});
      return this.loading;
    }
    origin(query,places){
      if(/^\d{5}$/.test(query)){
        const exact=places.filter(r=>r[0]===query);
        if(exact.length)return {point:this.centre(exact),approximate:false};
        const area=places.filter(r=>r[0].startsWith(query.slice(0,2)));
        if(area.length)return {point:this.centre(area),approximate:true};
        return null;
      }
      const exact=places.filter(r=>this.normalize(r[1])===query);
      if(!exact.length)return null;
      const centre=this.centre(exact);
      if(exact.some(r=>this.distance(centre,[r[2],r[3]])>35))return {ambiguous:true};
      return {point:centre,approximate:false};
    }
    cardPoint(card,places){
      const lat=Number(card.dataset.latitude),lon=Number(card.dataset.longitude);
      if(card.dataset.latitude&&card.dataset.longitude&&Number.isFinite(lat)&&Number.isFinite(lon)&&lat>=-90&&lat<=90&&lon>=-180&&lon<=180)return [lat,lon];
      const rows=places.filter(r=>r[0]===card.dataset.postcode);
      const city=rows.filter(r=>this.normalize(r[1])===this.normalize(card.dataset.city));
      return (city.length||rows.length)?this.centre(city.length?city:rows):null;
    }
    render(cards,message='',ranked=null,approximate=false){
      const visible=new Set(cards);
      const order=ranked?ranked.map(r=>r.card):this.cards;
      order.concat(this.cards.filter(card=>!order.includes(card))).forEach(card=>this.grid.append(card));
      this.cards.forEach(card=>{
        card.hidden=!visible.has(card);
        card.classList.toggle('is-nearest',Boolean(ranked&&card===ranked[0]?.card));
        const distance=card.querySelector('[data-distance]');
        const match=ranked?.find(r=>r.card===card);
        distance.hidden=!match||approximate;
        distance.textContent=match?this.status.dataset.distance.replace('{km}',String(Math.round(match.km))):'';
        card.querySelector('[data-nearest]').hidden=!match||card!==ranked[0]?.card;
      });
      const count=this.querySelector('[data-count]');
      count.textContent=[cards.length,cards.length===1?count.dataset.singular:count.dataset.plural,count.dataset.suffix].join(' ');
      this.status.textContent=message||this.status.dataset.hint;
      this.querySelector('[data-clear]').hidden=!this.search.value;
      this.querySelector('[data-reset]').hidden=!this.search.value&&this.region==='all';
      this.querySelectorAll('[data-region]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.region===this.region)));
    }
    async filter(){
      const version=++this.version;
      const query=this.normalize(this.search.value);
      const direct=this.cards.filter(card=>(this.region==='all'||card.dataset.regionValue===this.region)&&this.normalize(card.dataset.searchText).includes(query));
      if(!query){this.render(direct.length?direct:this.cards);return;}
      if(/^\d{1,4}$/.test(query)){this.render(this.cards,this.status.dataset.partial);return;}
      if(/\d/.test(query)&&!/^\d{5}$/.test(query)){this.render(direct.length?direct:this.cards,this.status.dataset.invalid);return;}
      this.render(direct.length?direct:this.cards,this.status.dataset.loading);
      try{
        const places=await this.loadPlaces();
        if(version!==this.version||!this.isConnected)return;
        const origin=this.origin(query,places);
        if(origin?.point){
          const all=this.cards.map(card=>({card,point:this.cardPoint(card,places)})).filter(r=>r.point).map(r=>({card:r.card,km:this.distance(origin.point,r.point)})).sort((a,b)=>a.km-b.km);
          const ranked=all.slice(0,Math.min(8,Math.max(1,Number(this.dataset.nearestCount)||3)));
          if(ranked.length){this.render(ranked.map(r=>r.card),origin.approximate?this.status.dataset.approximate:this.status.dataset.nearby,ranked,origin.approximate);return;}
        }
        this.render(direct.length?direct:this.cards,origin?.ambiguous?this.status.dataset.ambiguous:direct.length?this.status.dataset.direct:this.status.dataset.unknown);
      }catch{if(version===this.version&&this.isConnected)this.render(direct.length?direct:this.cards,this.status.dataset.unavailable);}
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wpc-whirli-chat"] && !Shopify.designMode) return;
  try {
    
(function () {
class WhirliStarterError extends Error {
    constructor(uncertain) {
        super(uncertain ? 'Message delivery not confirmed' : 'Conversation not ready');
        this.name = 'WhirliStarterError';
        this.uncertain = uncertain;
    }
}
function createWhirliStarterSender(launch, target = window, timeoutMs = 45000) {
    let conversationOpen = false;
    let pending = null;
    let wake;
    let cancel;
    const opened = () => { conversationOpen = true; wake?.(); };
    const closed = () => { conversationOpen = false; cancel?.(); };
    const minimized = () => cancel?.();
    target.addEventListener('onEmbeddedMessagingConversationOpened', opened);
    target.addEventListener('onEmbeddedMessagingConversationClosed', closed);
    target.addEventListener('onEmbeddedMessagingWindowClosed', closed);
    target.addEventListener('onEmbeddedMessagingWindowMinimized', minimized);
    return {
        hasConversation: () => conversationOpen,
        send(question) {
            if (pending)
                return pending;
            if (!question.trim() || question.length > 200)
                return Promise.reject(new WhirliStarterError(false));
            const operation = new Promise((resolve, reject) => {
                let finished = false;
                let attempted = false;
                let chat;
                const finish = (error) => {
                    if (finished)
                        return;
                    finished = true;
                    clearTimeout(timer);
                    wake = undefined;
                    cancel = undefined;
                    if (error)
                        reject(error);
                    else
                        resolve();
                };
                const timer = setTimeout(() => finish(new WhirliStarterError(attempted)), timeoutMs);
                wake = () => {
                    if (finished || attempted || !conversationOpen || !chat)
                        return;
                    if (!chat.utilAPI.sendTextMessage) {
                        finish(new WhirliStarterError(false));
                        return;
                    }
                    attempted = true;
                    try {
                        Promise.resolve(chat.utilAPI.sendTextMessage(question)).then(() => finish(), () => finish(new WhirliStarterError(true)));
                    }
                    catch {
                        finish(new WhirliStarterError(true));
                    }
                };
                cancel = () => finish(new WhirliStarterError(attempted));
                Promise.resolve().then(() => finished ? undefined : launch()).then(value => {
                    if (finished)
                        return;
                    chat = value;
                    wake?.();
                }, finish);
            });
            pending = operation;
            const release = () => { if (pending === operation)
                pending = null; };
            operation.then(release, release);
            return operation;
        },
        dispose() {
            cancel?.();
            target.removeEventListener('onEmbeddedMessagingConversationOpened', opened);
            target.removeEventListener('onEmbeddedMessagingConversationClosed', closed);
            target.removeEventListener('onEmbeddedMessagingWindowClosed', closed);
            target.removeEventListener('onEmbeddedMessagingWindowMinimized', minimized);
        },
    };
}

function secureSalesforceUrl(value) {
    const url = new URL(value);
    if (url.protocol !== 'https:' || url.username || url.password ||
        !/\.(my\.site\.com|force\.com|salesforce\.com|salesforce-scrt\.com)$/.test(url.hostname)) {
        throw new Error('Invalid Salesforce chat origin');
    }
    return url;
}
function validateChatConfig(config) {
    if (!/^00D[a-zA-Z0-9]{12}(?:[a-zA-Z0-9]{3})?$/.test(config.orgId) ||
        !/^[a-zA-Z][a-zA-Z0-9_]*$/.test(config.deploymentName)) {
        throw new Error('Invalid Salesforce deployment');
    }
    const site = secureSalesforceUrl(config.siteUrl);
    const script = secureSalesforceUrl(config.scriptUrl);
    secureSalesforceUrl(config.scrt2Url);
    if (script.origin !== site.origin || !script.pathname.endsWith('/assets/js/bootstrap.min.js')) {
        throw new Error('Invalid Salesforce bootstrap script');
    }
}
class SalesforceChatTimeout extends Error {
    constructor(stage) {
        super('Salesforce chat ' + stage + ' timed out');
        this.name = 'SalesforceChatTimeout';
        this.stage = stage;
    }
}
class SalesforceChatDismissed extends Error {
    constructor(reason) {
        super('Chat ' + reason + ' by the visitor');
        this.name = 'SalesforceChatDismissed';
        this.reason = reason;
    }
}
function withDeadline(operation, timeoutMs, stage) {
    return new Promise((resolve, reject) => {
        const timer = setTimeout(() => reject(new SalesforceChatTimeout(stage)), timeoutMs);
        operation.then(value => { clearTimeout(timer); resolve(value); }, error => { clearTimeout(timer); reject(error); });
    });
}
function createSalesforceChatLoader(config, timeoutMs = 30000) {
    let initialization;
    let waiting;
    let scriptFailed = false;
    function initialize() {
        return new Promise((resolve, reject) => {
            try {
                validateChatConfig(config);
            }
            catch (error) {
                reject(error);
                return;
            }
            let settled = false;
            const script = document.createElement('script');
            script.id = 'whirli-salesforce-bootstrap';
            script.src = config.scriptUrl;
            script.async = true;
            script.referrerPolicy = 'strict-origin-when-cross-origin';
            const finish = (error) => {
                if (settled)
                    return;
                settled = true;
                window.removeEventListener('onEmbeddedMessagingButtonCreated', ready);
                script.onload = null;
                script.onerror = null;
                if (error)
                    reject(error);
                else
                    resolve(window.embeddedservice_bootstrap);
            };
            const ready = () => {
                if (window.embeddedservice_bootstrap?.utilAPI?.launchChat)
                    finish();
                else
                    finish(new Error('Salesforce chat API unavailable'));
            };
            window.addEventListener('onEmbeddedMessagingButtonCreated', ready);
            script.onerror = () => {
                scriptFailed = true;
                script.remove();
                finish(new Error('Salesforce chat script could not be loaded'));
            };
            script.onload = () => {
                if (settled)
                    return;
                try {
                    const chat = window.embeddedservice_bootstrap;
                    if (!chat)
                        throw new Error('Salesforce chat bootstrap unavailable');
                    chat.settings.language = 'de';
                    chat.settings.hideChatButtonOnLoad = true;
                    chat.settings.chatButtonPosition = 'var(--whirli-bottom),var(--whirli-right)';
                    chat.settings.shouldOpenLinksInSameTab = false;
                    chat.settings.shouldMinimizeWindowOnNewTab = true;
                    chat.settings.disableLaunchChatOnInit = true;
                    chat.init(config.orgId, config.deploymentName, config.siteUrl, { scrt2URL: config.scrt2Url });
                }
                catch (error) {
                    finish(error instanceof Error ? error : new Error('Salesforce chat initialization failed'));
                }
            };
            document.body.appendChild(script);
        });
    }
    return function loadChat() {
        if (waiting)
            return waiting;
        if (!initialization || scriptFailed) {
            scriptFailed = false;
            initialization = initialize();
        }
        const attempt = withDeadline(initialization, timeoutMs, 'prepare');
        waiting = attempt;
        const release = () => { if (waiting === attempt)
            waiting = undefined; };
        attempt.then(release, release);
        return attempt;
    };
}
function createSalesforceChatLauncher(loadChat, timeoutMs = 20000, onOpened) {
    let launching;
    return async function openChat() {
        const chat = await loadChat();
        if (!launching) {
            const operation = confirmChatOpen(chat).then(() => { onOpened?.(); return chat; });
            launching = operation;
            const release = () => { if (launching === operation)
                launching = undefined; };
            operation.then(release, release);
        }
        return withDeadline(launching, timeoutMs, 'open');
    };
}
function confirmChatOpen(chat) {
    return new Promise((resolve, reject) => {
        let finished = false;
        let launchCompleted = false;
        let sawMaximized = false;
        let restoreCorrectionSent = false;
        const frame = () => chat.utilAPI.getEmbeddedMessagingFrame();
        const startedMinimized = !!frame()?.classList.contains('isMinimized');
        const finish = (error) => {
            if (finished)
                return;
            finished = true;
            window.removeEventListener('onEmbeddedMessagingWindowMaximized', maximized);
            window.removeEventListener('onEmbeddedMessagingWindowMinimized', minimized);
            window.removeEventListener('onEmbeddedMessagingWindowClosed', closed);
            window.removeEventListener('onEmbeddedMessagingInitError', failed);
            if (error)
                reject(error);
            else
                resolve();
        };
        const check = () => {
            if (finished || !launchCompleted)
                return;
            const current = frame();
            if (current?.classList.contains('isMaximized') && current.style.visibility !== 'hidden') {
                finish();
            }
            else if (current?.classList.contains('isMinimized') && !startedMinimized && !sawMaximized && !restoreCorrectionSent) {
                restoreCorrectionSent = true;
                launchCompleted = false;
                launch();
            }
        };
        const launch = () => {
            Promise.resolve().then(() => {
                if (!finished)
                    return chat.utilAPI.launchChat();
            }).then(() => { launchCompleted = true; check(); }, error => {
                finish(error instanceof Error ? error : new Error('Chat could not be opened'));
            });
        };
        const maximized = () => { sawMaximized = true; check(); };
        const minimized = () => {
            if (sawMaximized)
                finish(new SalesforceChatDismissed('minimized'));
            else
                check();
        };
        const closed = () => finish(new SalesforceChatDismissed('closed'));
        const failed = () => finish(new Error('Chat initialization failed'));
        window.addEventListener('onEmbeddedMessagingWindowMaximized', maximized);
        window.addEventListener('onEmbeddedMessagingWindowMinimized', minimized);
        window.addEventListener('onEmbeddedMessagingWindowClosed', closed);
        window.addEventListener('onEmbeddedMessagingInitError', failed);
        launch();
    });
}

(function () {
  if (window.WPCWhirliShop) return;
  window.WPCWhirliShop = {version: '2026-09-25'};
  const config = {
    orgId: '00D0Y000002Fi5e',
    deploymentName: 'WPC_Kundenapp',
    siteUrl: 'https://whirlpool-center.my.site.com/ESWWPCKundenapp1789462585488',
    scriptUrl: 'https://whirlpool-center.my.site.com/ESWWPCKundenapp1789462585488/assets/js/bootstrap.min.js',
    scrt2Url: 'https://whirlpool-center.my.salesforce-scrt.com'
  };
  const loadChat = createSalesforceChatLoader(config);
  const launchChat = createSalesforceChatLauncher(loadChat, 20000, () => window.dispatchEvent(new Event('whirli-chat-opened')));
  const starterSender = createWhirliStarterSender(launchChat);
  let detach;
  let warmed = false;
  function mount() {
    if (detach) detach();
    const root = document.querySelector('wpc-whirli');
    if (!root) return;
    const messages = JSON.parse(root.querySelector('[data-wpc-messages]').textContent);
    const button = root.querySelector('[data-wpc-open]');
    const subtitle = root.querySelector('[data-wpc-subtitle]');
    const status = root.querySelector('[data-wpc-status]');
    const errorBox = root.querySelector('[data-wpc-error]');
    const errorTitle = root.querySelector('[data-wpc-error-title]');
    const errorText = root.querySelector('[data-wpc-error-text]');
    const retry = root.querySelector('[data-wpc-retry]');
    const starters = root.querySelector('[data-wpc-starters]');
    const starterButtons = root.querySelectorAll('[data-wpc-starter]');
    const notice = root.querySelector('[data-wpc-send-notice]');
    const abort = new AbortController();
    const on = (node, event, listener, options = {}) => node.addEventListener(event, listener, {...options, signal: abort.signal});
    let busy = false;
    let timer;
    let warmTimer;
    let frame = 0;
    let trigger;
    const rootStyle = document.documentElement.style;
    const designMode = !!window.Shopify?.designMode;
    const setBusy = value => {
      busy = value;
      button.disabled = value;
      retry.disabled = value;
      starters.querySelectorAll('button').forEach(item => {item.disabled = value;});
      button.setAttribute('aria-busy', String(value));
      root.dataset.busy = String(value);
      subtitle.textContent = value ? messages.loading : root.dataset.subtitle;
      status.textContent = value ? messages.loading : '';
      clearTimeout(timer);
      if (value) timer = setTimeout(() => {subtitle.textContent = messages.slow_loading; status.textContent = messages.slow_loading;}, 8000);
    };
    const hideTopics = () => {starters.hidden = true; button.setAttribute('aria-expanded', 'false');};
    const opened = () => {root.dataset.native = 'true'; errorBox.hidden = true; hideTopics(); position();};
    const closed = () => {delete root.dataset.native; trigger?.focus({preventScroll:true}); position();};
    async function open(question) {
      if (designMode) {status.textContent = messages.editor_hint; return;}
      if (busy) return;
      trigger = document.activeElement;
      setBusy(true);
      errorBox.hidden = true;
      notice.hidden = true;
      try {
        const prior = window.embeddedservice_bootstrap;
        if (prior && !document.getElementById('whirli-salesforce-bootstrap')) throw new Error('Another messaging deployment is already initialized');
        if (typeof question === 'string') await starterSender.send(question);
        else await launchChat();
      } catch (error) {
        if (typeof question === 'string' && error instanceof WhirliStarterError) {
          root.querySelector('[data-wpc-selected]').textContent = question;
          notice.hidden = false;
          hideTopics();
        } else if (error instanceof SalesforceChatDismissed) {
          closed();
        } else {
          errorTitle.textContent = error instanceof SalesforceChatTimeout ? messages.slow_title : messages.error_title;
          errorText.textContent = error instanceof SalesforceChatTimeout ? messages.slow_text : messages.error_text;
          errorBox.hidden = false;
          delete root.dataset.native;
        }
      } finally {setBusy(false);}
    }
    function chooseTopic() {
      if (designMode) {status.textContent = messages.editor_hint; return;}
      if (busy) return;
      if (starterSender.hasConversation()) {void open(); return;}
      starters.hidden = !starters.hidden;
      button.setAttribute('aria-expanded', String(!starters.hidden));
      if (!starters.hidden) starters.querySelector('.wpc-whirli__wa-choice')?.focus();
    }
    function updatePosition() {
      frame = 0;
      const mobile = window.innerWidth <= 700;
      const base = Number(mobile ? root.dataset.mobileBottom : root.dataset.bottom) || 24;
      let bottom = base;
      const launchRect = root.getBoundingClientRect();
      for (const obstacle of document.querySelectorAll('.sticky-atc')) {
        const style = getComputedStyle(obstacle);
        const rect = obstacle.getBoundingClientRect();
        if (style.display === 'none' || style.visibility === 'hidden' || Number(style.opacity) === 0 || !rect.width || !rect.height) continue;
        if (rect.bottom > window.innerHeight * .6 && rect.left < launchRect.right && rect.right > launchRect.left) bottom = Math.max(bottom, window.innerHeight - rect.top + 12);
      }
      const footer = document.querySelector('footer .main_footer') || document.querySelector('footer');
      if (footer) {
        const rect = footer.getBoundingClientRect();
        if (rect.top < window.innerHeight && rect.bottom > 0) bottom = Math.max(bottom, window.innerHeight - rect.top + 12);
      }
      const value = `calc(${Math.round(bottom)}px + env(safe-area-inset-bottom, 0px))`;
      root.style.setProperty('--wpc-whirli-bottom', value);
      const controlBottom = Math.min(bottom, Math.max(base, window.innerHeight - 150));
      rootStyle.setProperty('--wpc-whirli-top-button-bottom', `calc(${Math.round(controlBottom + (root.offsetHeight || 64) + 12)}px + env(safe-area-inset-bottom, 0px))`);
      rootStyle.setProperty('--whirli-bottom', `calc(${Math.round(controlBottom)}px + env(safe-area-inset-bottom, 0px))`);
      rootStyle.setProperty('--whirli-right', mobile ? '16px' : '24px');
    }
    function position() {if (!frame) frame = requestAnimationFrame(updatePosition);}
    function prepare() {
      const connection = navigator.connection;
      if (designMode || warmed || document.visibilityState === 'hidden' || connection?.saveData || /(^|-)2g$/.test(connection?.effectiveType || '')) return;
      clearTimeout(warmTimer);
      warmTimer = setTimeout(() => {
        if (window.embeddedservice_bootstrap && !document.getElementById('whirli-salesforce-bootstrap')) return;
        warmed = true;
        void loadChat().catch(() => {});
      }, 1500);
    }
    on(button, 'click', chooseTopic);
    on(retry, 'click', () => void open());
    on(root.querySelector('[data-wpc-own]'), 'click', () => void open());
    starterButtons.forEach(item => on(item, 'click', () => void open(item.dataset.wpcStarter)));
    on(root.querySelector('[data-wpc-close-starters]'), 'click', () => {hideTopics(); button.focus();});
    on(starters, 'keydown', event => {if (event.key === 'Escape' && !busy) {event.preventDefault(); hideTopics(); button.focus();}});
    on(root.querySelector('[data-wpc-close-notice]'), 'click', () => {notice.hidden = true;});
    on(root.querySelector('[data-wpc-notice-open]'), 'click', () => void open());
    on(root.querySelector('[data-wpc-dismiss]'), 'click', () => {errorBox.hidden = true; button.focus();});
    on(window, 'whirli-chat-opened', opened);
    on(window, 'onEmbeddedMessagingWindowClosed', closed);
    on(window, 'onEmbeddedMessagingWindowMinimized', closed);
    on(window, 'scroll', position, {passive:true});
    on(window, 'resize', position);
    if (window.visualViewport) on(window.visualViewport, 'resize', position);
    on(document, 'visibilitychange', prepare);
    if (document.readyState === 'complete') prepare();
    else on(window, 'load', prepare, {once:true});
    updatePosition();
    const resizeObserver = new ResizeObserver(position);
    resizeObserver.observe(root);
    const existingFrame = window.embeddedservice_bootstrap?.utilAPI?.getEmbeddedMessagingFrame?.();
    if (existingFrame?.classList.contains('isMaximized')) opened();
    detach = () => {abort.abort(); clearTimeout(timer); clearTimeout(warmTimer); cancelAnimationFrame(frame); resizeObserver.disconnect();};
  }
  mount();
  document.addEventListener('shopify:section:load', mount);
  document.addEventListener('shopify:section:unload', event => {if (event.target.querySelector('wpc-whirli') && detach) detach();});
}());

}());

  } catch(e) { console.error(e); }
})();
})();
